import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#0A0A0A] border-t border-[#2A2A2A]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-3xl font-bold text-[#EDEDED] mb-4">BARBAAR</h3>
            <p className="font-body text-[#A1A1A1] leading-relaxed">
              {t.footer.description}
            </p>
            <p className="font-body text-[#C8A46A] mt-3 text-sm tracking-wide">
              {t.footer.tagline}
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-[#EDEDED] mb-4 tracking-wide">{t.footer.contact}</h4>
            <div className="space-y-3">
              <a 
                href="https://maps.google.com/?q=Parijsstraat+26,+8430+Middelkerke"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-3 text-[#A1A1A1] hover:text-copper transition-colors"
                data-testid="footer-address"
              >
                <MapPin size={18} className="mt-1 flex-shrink-0 text-copper" />
                <span className="font-body text-sm">Parijsstraat 26<br />8430 Middelkerke</span>
              </a>
              <a 
                href="tel:+32000000000"
                className="flex items-center gap-3 text-[#A1A1A1] hover:text-copper transition-colors"
                data-testid="footer-phone"
              >
                <Phone size={18} className="flex-shrink-0 text-copper" />
                <span className="font-body text-sm">+32 (0) XX XX XX XX</span>
              </a>
              <a 
                href="mailto:info@barbaarmiddelkerke.com"
                className="flex items-center gap-3 text-[#A1A1A1] hover:text-copper transition-colors"
                data-testid="footer-email"
              >
                <Mail size={18} className="flex-shrink-0 text-copper" />
                <span className="font-body text-sm">info@barbaarmiddelkerke.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links & Social */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-[#EDEDED] mb-4 tracking-wide">{t.footer.navigation}</h4>
            <div className="grid grid-cols-2 gap-2 mb-6">
              <Link to="/menu" className="font-body text-sm text-[#A1A1A1] hover:text-copper transition-colors" data-testid="footer-link-menu">{t.nav.menu}</Link>
              <Link to="/fotos" className="font-body text-sm text-[#A1A1A1] hover:text-copper transition-colors" data-testid="footer-link-fotos">{t.nav.photos}</Link>
              <Link to="/contact" className="font-body text-sm text-[#A1A1A1] hover:text-copper transition-colors" data-testid="footer-link-contact">{t.nav.contact}</Link>
              <Link to="/locatie" className="font-body text-sm text-[#A1A1A1] hover:text-copper transition-colors" data-testid="footer-link-locatie">{t.nav.location}</Link>
            </div>
            
            <h4 className="font-heading text-lg font-semibold text-[#EDEDED] mb-4 tracking-wide">{t.footer.followUs}</h4>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/barbaar_middelkerke/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-sm bg-[#141414] border border-[#2A2A2A] flex items-center justify-center text-[#A1A1A1] hover:text-copper hover:border-copper transition-all"
                data-testid="footer-instagram"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a 
                href="https://www.facebook.com/barbaar.middelkerke/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-sm bg-[#141414] border border-[#2A2A2A] flex items-center justify-center text-[#A1A1A1] hover:text-copper hover:border-copper transition-all"
                data-testid="footer-facebook"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#2A2A2A] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-[#A1A1A1]">
            © {new Date().getFullYear()} BARBAAR Middelkerke. {t.footer.rights}
          </p>
          <p className="font-body text-xs text-[#A1A1A1]">
            {t.footer.responsible}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
